export const dayOfWeekEnum = {
    SATURDAY:"شنبه",
    SUNDAY:"یک شنبه",
    MONDAY:"دوشنبه",
    TUESDAY:"سه شنبه",
    WEDNESDAY:"چهارشنبه",
    THURSDAY:"پنج شنبه",
    FRIDAY:"جمعه"

}
